import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { TICKET_PRODUCT_REVIEW_LIST_QUERY } from "../Queries";
import useInput from "../../../../../Hooks/useInput";
import Presenter from "./Presenter";
import qs from "qs";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));
  var page = queryString.page ? queryString.page : 1;
  const ticketProduct = queryString.ticketProduct
    ? queryString.ticketProduct
    : "";
  var keyword = queryString.keyword ? queryString.keyword : "";
  const keywordInput = useInput(keyword);
  const blockSize = 5;
  const first = 15;
  const skip = first * (page - 1);
  const baseUrl =
    "?" +
    (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "") +
    (ticketProduct ? "ticketProduct=" + ticketProduct + "&" : "");

  const { data, loading } = useQuery(TICKET_PRODUCT_REVIEW_LIST_QUERY, {
    variables: {
      ticketProduct,
      keyword,
      skip,
      first,
    },
  });

  const handleSearch = (e) => {
    e.preventDefault();
    history.push(`/ticket/ticketProductReviews${baseUrl}page=1`);
  };

  return (
    <>
      <Presenter
        history={history}
        match={match}
        location={location}
        page={page}
        ticketProduct={ticketProduct}
        keyword={keyword}
        keywordInput={keywordInput}
        blockSize={blockSize}
        first={first}
        skip={skip}
        data={data}
        loading={loading}
        baseUrl={baseUrl}
        handleSearch={handleSearch}
      ></Presenter>
    </>
  );
});
